import { useState } from 'preact/hooks';
import { HeaderContent } from './types';

export const css = `
  .page-header {
    .logo {
      color: var(--c-primary-6);
    }
  }
`;

export function View({ data }: { data: HeaderContent }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const navItems = () => (
    <>
      {' '}
      {data.navigation.map((item) => (
        <li key={item.id}>
          <a
            href={item.href}
            class="nav-link relative py-2 text-inherit"
            aria-current={item.isActive ? 'page' : undefined}
          >
            {item.text}
          </a>
        </li>
      ))}
    </>
  );

  return (
    <>
      {/* Mobile Menu - Hidden by default */}
      <div
        class={`md:hidden fixed top-0 inset-x-0 bg-white transform pt-16 pb-10 z-40 ${
          isExpanded ? '' : '-translate-y-full opacity-0'
        } transition-all`}
        aria-hidden="true"
      >
        <nav class="px-8 py-6">
          <ul class="flex flex-col items-end gap-4">{navItems()}</ul>
        </nav>
      </div>
      {/* The page header content */}
      <header class="page-header sticky w-full top-0 inset-x-0 z-50 bg-white/75 backdrop-blur-lg transition-all duration-300 py-6">
        <div class="max-w-7xl mx-auto px-8 flex justify-between items-center">
          <a href={data.logo.href} class="logo font-bold text-2xl">
            {data.logo.text}
          </a>

          <nav>
            <ul class="hidden md:flex items-center gap-8">{navItems()}</ul>
          </nav>

          <button
            class={`mobile-toggle md:hidden text-2xl cursor-pointer transition-all ${
              isExpanded ? 'rotate-90' : ''
            }`}
            aria-label={data.mobileMenuAriaLabel}
            aria-expanded={isExpanded}
            onClick={() => setIsExpanded((x) => !x)}
          >
            {isExpanded ? '✕' : '☰'}
          </button>
        </div>
      </header>
    </>
  );
}
